// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"965a0b79e76dce7def2e","418":"a345e21b32c50fb955af"}[chunkId] + ".js";
};